(function () {
  'use strict';

  var SELECTOR = '[data-mnj-promo-countdown]';

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function parseEnd(iso) {
    if (!iso) return NaN;
    var t = Date.parse(iso);
    return Number.isFinite(t) ? t : NaN;
  }

  function parseRollingHours(root) {
    var raw = root.getAttribute('data-countdown-rolling-hours');
    if (raw == null || raw === '') return 0;
    var hours = parseFloat(raw);
    return Number.isFinite(hours) && hours > 0 ? hours : 0;
  }

  /** Next local-time boundary for an N-hour repeating window (e.g. 6h → 12am, 6am, 12pm, 6pm). */
  function rollingEndMs(nowMs, hours) {
    var periodMs = hours * 60 * 60 * 1000;
    var d = new Date(nowMs);
    var startOfDay = new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
    var msIntoDay = nowMs - startOfDay;
    var endOffset = Math.ceil(msIntoDay / periodMs) * periodMs;
    if (endOffset >= 86400000) {
      return startOfDay + 86400000;
    }
    return startOfDay + endOffset;
  }

  function resolveEndMs(root, nowMs) {
    var rollingHours = parseRollingHours(root);
    if (rollingHours > 0) {
      return { endMs: rollingEndMs(nowMs, rollingHours), rolling: true };
    }
    var endMs = parseEnd(root.getAttribute('data-countdown-end'));
    if (!Number.isFinite(endMs)) return null;
    return { endMs: endMs, rolling: false };
  }

  function tick(root) {
    var resolved = resolveEndMs(root, Date.now());
    if (!resolved) return;

    var endMs = resolved.endMs;
    var now = Date.now();
    var diff = endMs - now;
    var expired = root.querySelector('[data-countdown-expired]');
    var grid = root.querySelector('[data-countdown-grid]');

    if (!resolved.rolling && diff <= 0) {
      if (grid) grid.hidden = true;
      if (expired) expired.hidden = false;
      return;
    }

    if (resolved.rolling && diff <= 0) {
      endMs = rollingEndMs(now, parseRollingHours(root));
      diff = endMs - now;
    }

    if (grid) grid.hidden = false;
    if (expired) expired.hidden = true;

    var totalSec = Math.max(0, Math.floor(diff / 1000));
    var days = Math.floor(totalSec / 86400);
    totalSec %= 86400;
    var hours = Math.floor(totalSec / 3600);
    totalSec %= 3600;
    var mins = Math.floor(totalSec / 60);
    var secs = totalSec % 60;

    var daysEl = root.querySelector('[data-unit="days"]');
    var hoursEl = root.querySelector('[data-unit="hours"]');
    var minsEl = root.querySelector('[data-unit="mins"]');
    var secsEl = root.querySelector('[data-unit="secs"]');

    if (daysEl) daysEl.textContent = pad(days);
    if (hoursEl) hoursEl.textContent = pad(hours);
    if (minsEl) minsEl.textContent = pad(mins);
    if (secsEl) secsEl.textContent = pad(secs);

    var label = root.querySelector('[data-countdown-aria]');
    if (label) {
      label.textContent =
        days + ' days, ' + hours + ' hours, ' + mins + ' minutes, ' + secs + ' seconds remaining';
    }
  }

  function init() {
    var nodes = document.querySelectorAll(SELECTOR);
    if (!nodes.length) return;

    nodes.forEach(tick);
    window.setInterval(function () {
      nodes.forEach(tick);
    }, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
